import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentTab,
  addUserAddress,
  addUserContact,
  addUserDetail,
  setDisableFrom,
  updateRegistrationDetail,
  documentFileUpload,
  setBannerUri,
  setProfileUri,
  addEntityDocuments,
} from "./slice";
import { setDashboardTab } from "../DashBoardView/slice";
import {
  register,
  setIdentitifcationType,
} from "../../redux/features/authSlice";
import InfoIcon from "@mui/icons-material/Info";
import { LoadingButton } from "@mui/lab";

import { useNavigate } from "react-router";

import * as Yup from "yup";

import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import CircularProgress from "@mui/material/CircularProgress";

import React, { useState, useEffect } from "react";

import BlogPostCard from "../../sections/auth/register/uploadCard";

import { responsiveValue } from "../../theme/Styles/responsiveValue";

import { ArrowForward } from "@mui/icons-material";

import "./Style.css";

import { FormProvider, RHFTextField } from "../../components/hook-form";

import BackButton from "../../components/BackButton";

import { AddressData } from "../../common/enum/addressData";

import {
  ComponentType,
  UserType,
  RegistrationStatus,
  DocumentStatus,
  FileType,
} from "../../common/enum";

import MapLeaflet from "../MapLeaflet";
import { getProductList } from "../DonationView/slice";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import { useSnackbar } from "notistack";
import { useData } from './DataContext';
import { CheckNIF, CheckNome } from "../../redux/features/authSlice";
import Tooltip from '@mui/material/Tooltip';


const IdentificationRegister = ({
  t,
  setBlock,
  block,
  editAddress,

  identificationType,
}) => {
  const { setSharedData } = useData();
  const { sharedData } = useData();

  // Extract individual pieces of data
  const { data } = sharedData;
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [select1, setSelect1] = useState(sharedData.select1);
  const [select2, setSelect2] = useState(sharedData.select2);
  const [open, setOpen] = useState(true);
  const [submitCount, setSubmitCount] = useState(0);
  const [select3, setSelect3] = useState(sharedData.select3);
  const [showError, setShowError] = useState(null);
  const [businessRegistration, setBusinessRegistration] = useState(null);
  const [mandatedStatement, setMandatedStatement] = useState(null);
  const [businessRegPercentage, setbusinessRegPercentage] = useState(0);
  const [businessRegistrationUri, setBusinessRegistrationUri] = useState(sharedData.businessRegistrationUri);
  const [mandatePercentage, setMandatePercentage] = useState(0);
  const [mandatedStatementUri, setMandatedStatementUri] = useState(sharedData.mandatedStatementUri);
  const [businessRegError, setBusinessRegError] = useState(false);
  const { details, setDetails } = useData();
  const [base64Data, setBase64Data] = useState(null);
  const [base64DataMandate, setBase64DataMandate] = useState(null);

  const [position, setPosition] = useState({
    lat: 38.736946,
    lng: -9.142685,
  });
  const [positionError, setPositionError] = useState(false);

  const businessRegistrationRef = React.useRef();

  const mandatedStatementRef = React.useRef();

  const {
    loading,
    onBoarding,
    auth: { user: { userId } = {}, profile: { entity } } = {},
  } = useSelector((state) => state);

  const {
    profileOptionsValue,
    activityOptionsValue,
    entityTypeOptionsValue,
    bannerUri,
    profileUri,
  } = onBoarding || {};

  const dispatch = useDispatch();
  // const  { onBoarding: }


  const identificationSchema = Yup.object().shape({
    NIF_NIPC: Yup.string().required(
      "O campo NIF / NIPC é de preenchimento obrigatório"
    )
      .matches(/^(\+[\d]{1,5}|0)?[0-9]+$/, "devem ser apenas números")
      .length(9, "NIF / NIPC tem que ter 9 dígitos")
      .test(
        "uniqueNIF",
        `Insira um número de identificação fiscal válido`,
        async function (value) {

          if (value !== undefined) {
            const primeiroCaractere = value.charAt(0);
            if (primeiroCaractere === '9' || primeiroCaractere === '8' || primeiroCaractere === '5' || primeiroCaractere === '6') {
              return true
            } else {
              return false
            }
          } else {
            return true
          }

        }

      )
      .test(
        "uniqueNIF",
        `O valor inserido no NIF / NIPC já existe`,
        async function (value) {
          if (value != undefined && value.length === 9) {
            try {
              const res = await dispatch(CheckNIF(value));
              if (res.payload.success == true) {
                return true;
              } else {
                return false;
              }
            } catch (error) {
              return false;
            }
          }

          return true;
        }
      ),
    companyName: Yup.string().required(
      `O campo ${t("name")} é de preenchimento obrigatório`
    ).test(
      "uniqueNIF",
      `O valor inserido no ${t("name")} já existe`,
      async function (value) {
        if (value != undefined) {
          try {
            const res = await dispatch(CheckNome(value));
            if (res.payload.success == true) {
              return true;
            } else {
              return false;
            }
          } catch (error) {
            return false;
          }
        }
        return true;
      }
    ),
    addressTitle: Yup.string().required(
      `O campo ${t("addressTitle")} é de preenchimento obrigatório`
    ),
    houseHold: Yup.string().required(
      `O campo ${t("houseHold")} é de preenchimento obrigatório`
    ),
    phone: Yup.string()
      .required(`O campo ${t("phone")} é de preenchimento obrigatório`)
      .matches(/^(\+[\d]{1,5}|0)?[0-9]+$/, "devem ser apenas números")
      .min(9, 'O campo contato telefónico deve ter no mínimo 9 dígitos')
      .max(12, 'O campo contato telefónico deve ter no máximo 12 dígitos'),
    emailForAddress: Yup.string()
      .email("Insira um e-mail válido")
      .required(`O campo ${t("emailForAddress")} é de preenchimento obrigatório`),
    district: Yup.mixed().test(
      "is-non-empty",
      `O campo ${t("district")} é de preenchimento obrigatório`,
      function (value) {
        if (typeof select1 === "string") {
          return !!select1.trim(); // Check if the trimmed string is not empty
        } else if (Array.isArray(select1)) {
          return select1.length > 0; // Check if it's a non-empty array
        } else {
          return false; // Any other type is invalid
        }
      }
    ),
    county: Yup.mixed().test(
      "is-non-empty",
      `O campo ${t("county")} é de preenchimento obrigatório`,
      function (value) {
        if (typeof select2 === "string") {
          return !!select2.trim(); // Check if the trimmed string is not empty
        } else if (Array.isArray(select2)) {
          return select2.length > 0; // Check if it's a non-empty array
        } else {
          return false; // Any other type is invalid
        }
      }
    ),
    parshi: Yup.mixed().test(
      "is-non-empty",
      `O campo ${t("parshi")} é de preenchimento obrigatório`,
      function (value) {
        if (typeof select3 === "string") {
          return !!select3.trim(); // Check if the trimmed string is not empty
        } else if (Array.isArray(select3)) {
          return select3.length > 0; // Check if it's a non-empty array
        } else {
          return false; // Any other type is invalid
        }
      }
    ),
    postalCode1: Yup.string()
      .required(`O campo ${t("postcard")} é de preenchimento obrigatório`)
      .matches(/^[0-9]+$/, "devem ser apenas números")
      .min(4, "Tem de ter 4 digitos")
      .max(4, "Tem de ter 4 digitos"),
    postalCode2: Yup.string()
      .required(`O campo ${t("postcard")} é de preenchimento obrigatório`)
      .matches(/^[0-9]+$/, "devem ser apenas números")
      .min(3, "Tem de ter 3 digitos")
      .max(3, "Tem de ter 3 digitos"),
    locality: Yup.string().required(
      `O campo ${t("locality")} é de preenchimento obrigatório`
    ),
    businessRegistration: Yup.mixed().test(
      "is-non-empty",
      `O campo ${t("businessRegistration")} é de preenchimento obrigatório`,
      function (value) {
        if (value && Array.isArray(value)) {
          return value.length > 0;
        } else {
          return false; // Se businessRegistration não existe ou não é um array
        }
      }
    ),
    mandatedStatement: Yup.mixed().test(
      "is-non-empty",
      `O campo ${t("mandatedStatement")} é de preenchimento obrigatório`,
      function (value) {
        if (value && Array.isArray(value)) {
          return value.length > 0;
        } else {
          return false; // Se mandatedStatement não existe ou não é um array
        }
      }
    ),

    contactName: Yup.string()
      .required()
      .required(`O campo ${t("contactName")} é de preenchimento obrigatório`),
    mobile: Yup.string()
      .required(`O campo ${t("mobile")} é de preenchimento obrigatório`)
      .matches(/^(\+[\d]{1,5}|0)?[0-9]+$/, "devem ser apenas números")
      .length(9, "O campo contato telefónico tem que ter 9 dígitos"),
    email: Yup.string()
      .email("Insira um e-mail válido")
      .required(`O campo e-mail é de preenchimento obrigatório`),
    designation: Yup.string().required(
      `O campo ${t("designation")} é de preenchimento obrigatório`
    ),
  });

  const addBranchSchema = Yup.object().shape({
    addressTitle: Yup.string().required(
      `O campo ${t("addressTitle")} é de preenchimento obrigatório`
    ),
    houseHold: Yup.string().required(
      `O campo ${t("houseHold")} é de preenchimento obrigatório`
    ),
    emailForAddress: Yup.string()
      .email("Insira um e-mail válido")
      .required(`O campo ${t("emailAddress")} é de preenchimento obrigatório`),
    phone: Yup.string()
      .required(`O campo ${t("phone")} é de preenchimento obrigatório`)
      .matches(/^(\+[\d]{1,5}|0)?[0-9]+$/, "devem ser apenas números"),
    district: Yup.mixed().test(
      "is-non-empty",
      `O campo ${t("district")} é de preenchimento obrigatório`,
      function (value) {
        if (typeof select1 === "string") {
          return !!select1.trim(); // Check if the trimmed string is not empty
        } else if (Array.isArray(select1)) {
          return select1.length > 0; // Check if it's a non-empty array
        } else {
          return false; // Any other type is invalid
        }
      }
    ),
    county: Yup.mixed().test(
      "is-non-empty",
      `O campo ${t("county")} é de preenchimento obrigatório`,
      function (value) {
        if (typeof select2 === "string") {
          return !!select2.trim(); // Check if the trimmed string is not empty
        } else if (Array.isArray(select2)) {
          return select2.length > 0; // Check if it's a non-empty array
        } else {
          return false; // Any other type is invalid
        }
      }
    ),
    parshi: Yup.mixed().test(
      "is-non-empty",
      `O campo ${t("parshi")} é de preenchimento obrigatório`,
      function (value) {
        if (typeof select3 === "string") {
          return !!select3.trim(); // Check if the trimmed string is not empty
        } else if (Array.isArray(select3)) {
          return select3.length > 0; // Check if it's a non-empty array
        } else {
          return false; // Any other type is invalid
        }
      }
    ),
    postalCode1: Yup.string()
      .required(`O campo ${t("postcard")} é de preenchimento obrigatório”`)
      .matches(/^[0-9]+$/, "devem ser apenas números")
      .min(4, "Tem de ter 4 digitos")
      .max(4, "Tem de ter 4 digitos"),
    postalCode2: Yup.string()
      .required(`O campo ${t("postcard")} é de preenchimento obrigatório`)
      .matches(/^[0-9]+$/, "devem ser apenas números")
      .min(3, "Tem de ter 3 digitos")
      .max(3, "Tem de ter 3 digitos"),

    locality: Yup.string().required(
      `O campo ${t("locality")} é de preenchimento obrigatório `
    ),
    contactName: Yup.string()
      .required()
      .required(`O campo ${t("contactName")} é de preenchimento obrigatório`),
    mobile: Yup.string()
      .required(`O campo ${t("mobile")} é de preenchimento obrigatório`)
      .matches(/^(\+[\d]{1,5}|0)?[0-9]+$/, "devem ser apenas números"),
    email: Yup.string()
      .email("Insira um e-mail válido")
      .required(`O campo e-mail é de preenchimento obrigatório`),
    designation: Yup.string().required(
      `O campo ${t("designation")} é de preenchimento obrigatório `
    ),
  });

  const defaultValues = {
    NIF_NIPC: Object(sharedData.data)["NIF_NIPC"],
    branchName: "",
    name: Object(sharedData.data)["name"],
    address: Object(sharedData.data)["address"],
    postalCode1: Object(sharedData.data)["postalCode1"],
    postalCode2: Object(sharedData.data)["postalCode2"],
    locality: Object(sharedData.data)["locality"],
    companyName: Object(sharedData.data)["companyName"],
    email: Object(sharedData.data)["email"],
    mobile: Object(sharedData.data)["mobile"],
    designation: Object(sharedData.data)["designation"],
    addressTitle: Object(sharedData.data)["addressTitle"],
    phone: Object(sharedData.data)["phone"],
    emailForAddress: Object(sharedData.data)["emailForAddress"],
    houseHold: Object(sharedData.data)["houseHold"],
    contactName: Object(sharedData.data)["contactName"],
    district: Object(sharedData.data)["district"],
    county: Object(sharedData.data)["county"],
    parshi: Object(sharedData.data)["parshi"],
    businessRegistration: (sharedData.data)["businessRegistration"],
    mandatedStatement: (sharedData.data)["mandatedStatement"],
    select1: (sharedData.select1),
    select2: (sharedData.select2),
    select3: (sharedData.select3),
  };
  // var defaultValues = {
  //   NIF_NIPC: "",
  //   branchName: "",
  //   name: "",
  //   address: "",
  //   postalCode1: "",
  //   postalCode2: "",
  //   locality: "",
  //   companyName: "",
  //   email: "",
  //   mobile: "",
  //   designation: "",
  //   addressTitle: "",
  //   phone: "",
  //   emailForAddress: "",
  // };

  const [formValues, setFormValues] = useState(defaultValues);

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const methods = useForm({
    resolver: identificationType
      ? yupResolver(addBranchSchema)
      : yupResolver(identificationSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;
  const onUploadProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    if (percent < 100) {
      setbusinessRegPercentage(percent);
    }
  };

  const onUploadProgressMandate = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    if (percent < 100) {
      setMandatePercentage(percent);
    }
  };

  const handleBusinessFileUpload = React.useCallback((e) => {
    setBusinessRegError(false);
    const data = new FormData();
    data.append("file", e.target.files[0]);

    //// teste base69 pdf para guardar na bd
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = btoa(reader.result);
        setBase64Data(base64String);
      };

      reader.readAsBinaryString(file);
    }
    dispatch(documentFileUpload({ data, onUploadProgress }))
      .unwrap()
      .then((res) => {
        setBusinessRegistrationUri(res.fileName);
        setbusinessRegPercentage(100);
        setTimeout(() => {
          setbusinessRegPercentage(0);
        }, 1000);
        setBusinessRegistration(e.target.files?.item(0).name);
      })
      .catch((error) => {
        //console.log(error);
      });

    if (businessRegistrationRef.current) {
      businessRegistrationRef.current.focus();
    }
  }, []);

  const handleMandateFileUpload = React.useCallback((e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    //// teste base69 pdf para guardar na bd
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = btoa(reader.result);
        setBase64DataMandate(base64String);
      };

      reader.readAsBinaryString(file);
    }
    const onUploadProgress = onUploadProgressMandate;

    dispatch(documentFileUpload({ data, onUploadProgress }))
      .unwrap()
      .then((res) => {
        setMandatedStatementUri(res.fileName);
        setMandatePercentage(100);
        setTimeout(() => {
          setMandatePercentage(0);
        }, 1000);
        setMandatedStatement(e.target.files?.item(0).name);
      })
      .catch((error) => {
        //console.log(error);
      });
    if (mandatedStatementRef.current) {
      mandatedStatementRef.current.focus();
    }
  }, []);

  const setMarkerSDefaultPosition = (value) => {
    setPosition(value);
    setPositionError(false);
  };

  const uploadDocumnetDetails = async (filetype, fileName) => {
    const documnetDetails = {
      loggedInUserId: userId,
      entityId: userId,
      updatedBy: userId,
      status: DocumentStatus.waitingForValidation,
      fileType: filetype,
      fileName: fileName,
    };
    dispatch(addEntityDocuments(documnetDetails));
  };

  // const onSubmit = async (data) => {
  //   const {
  //     name,
  //     NIF_NIPC,
  //     mobile,
  //     companyName,
  //     email,
  //     locality,
  //     address,
  //     postalCode1,
  //     postalCode2,
  //     designation,
  //     addressTitle,
  //     emailForAddress,
  //     phone,
  //     houseHold,
  //     contactName,
  //     ...addressData
  //   } = data;
  //   if (identificationType === ComponentType.IDENTIFICATION_TYPE) {
  //     if (position === null) {
  //       setPositionError(true);
  //     } else {
  //       setPositionError(false);
  //       const data = {
  //         email: emailForAddress.toLowerCase(),
  //         password: "Test123",
  //         userType: UserType.entity,
  //         status: RegistrationStatus.registering,
  //         createdBy: userId,
  //       };
  //       dispatch(setIdentitifcationType(identificationType));
  //       await dispatch(register({ data }))
  //         .unwrap()
  //         .then((res) => {
  //           console.log("res", res);
  //           const addressPayload = {
  //             entityId: res.userId,
  //             id: 0,
  //             addressTitle,
  //             addressLine: houseHold,
  //             district: select1,
  //             county: select2,
  //             subDivision: select3,
  //             postalCode: `${postalCode1}-${postalCode2}`,
  //             locality,
  //             latitude: position.lat,
  //             longitude: position.lng,
  //             phone,
  //             email: emailForAddress,
  //             isHeadquarter: false,
  //             isExternal: false,
  //             updatedBy: entity.entityId,
  //           };
  //           if (res.userId !== undefined) {

  //             dispatch(addUserAddress(addressPayload))
  //               .unwrap()
  //               .then((resAddress) => {
  //                 const contactPayload = {
  //                   entityId: res.userId,
  //                   name: contactName,
  //                   mobile,
  //                   email,
  //                   designation,
  //                   telephone: "",
  //                   isOfficialRepresentative: true,
  //                   isPrimaryContact: true,
  //                   updatedBy: entity.entityId,
  //                 };
  //                 dispatch(addUserContact(contactPayload))
  //                   .unwrap()
  //                   .then((responseContact) => {
  //                     const userDetails = {
  //                       entityName: companyName,
  //                       userTypeId: 0,
  //                       entityId: res.userId,
  //                       entityType: entity.entityType, //entityType //profileOption
  //                       nic: entity.nic,
  //                       websiteUrl: "string",
  //                       profilePicture: "string",
  //                       tin: "string",
  //                       occupation: "string",
  //                       isGroupEntity: entity.isGroupEntity, // entityTypeOption
  //                       areaOfActivity: entity.areaOfActivity, // activityOption
  //                       isParentEntity: false,
  //                       contactId: responseContact.contactDetails.contactId,
  //                       entityAddressId: resAddress.addressDetails.addressId,
  //                       cae: "string",
  //                       parentEntityId: entity.entityId,
  //                     };
  //                     dispatch(addUserDetail(userDetails))
  //                       .unwrap()
  //                       .then(() => {
  //                         const payload = {
  //                           userId: res.userId,
  //                           status: RegistrationStatus.invited,
  //                         };
  //                         dispatch(updateRegistrationDetail(payload))
  //                           .unwrap()
  //                           .then(() => {
  //                             navigate("/dashboard", { replace: true });
  //                             dispatch(setDashboardTab("manageBranches"));
  //                             dispatch(setIdentitifcationType(""));
  //                           });
  //                         enqueueSnackbar({
  //                           message: t("branchAddedSuccessfulMessage"),
  //                           variant: "success",
  //                         });
  //                       });
  //                   });
  //               });
  //           } else {
  //             enqueueSnackbar({
  //               message: t("emailAlreadyExist"),
  //               variant: "error",
  //             });
  //           }
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //           enqueueSnackbar({
  //             message: t("emailAlreadyExist"),
  //             variant: "error",
  //           });
  //         });
  //     }
  //   } else {
  //     if (
  //       businessRegistrationUri === null ||
  //       select1 === null ||
  //       select2 === null ||
  //       select3 === null ||
  //       position === null
  //     ) {
  //       if (select1 === null || select2 === null || select3 === null) {
  //         setShowError(true);
  //       }
  //       if (businessRegistrationUri === null) {
  //         setBusinessRegError(true);
  //       }
  //       if (position === null) {
  //         setPositionError(true);
  //       }
  //     } else {
  //       const payload = {
  //         entityId: userId,
  //         id: 0,
  //         addressTitle,
  //         addressLine: houseHold,
  //         district: select1,
  //         county: select2,
  //         subDivision: select3,
  //         postalCode: `${postalCode1}-${postalCode2}`,
  //         locality,
  //         latitude: position.lat,
  //         longitude: position.lng,
  //         phone,
  //         email: emailForAddress,
  //         isHeadquarter: true,
  //         isExternal: false,
  //       };

  //       const contactPayload = {
  //         entityId: userId,
  //         name: contactName,
  //         mobile,
  //         email,
  //         designation,
  //         telephone: "",
  //         isOfficialRepresentative: true,
  //         isPrimaryContact: true,
  //       };

  //       await dispatch(addUserAddress(payload))
  //         .unwrap()
  //         .then((successResult) => {
  //           dispatch(addUserContact(contactPayload))
  //             .unwrap()
  //             .then((contactResponse) => {
  //               const userDetails = {
  //                 entityName: companyName,
  //                 userTypeId: 0,
  //                 entityId: userId,
  //                 entityType: profileOptionsValue, //entityType //profileOption
  //                 nic: NIF_NIPC,
  //                 websiteUrl: "string",
  //                 profilePicture: profileUri.length > 0 ? profileUri : "string",
  //                 bannerImage: bannerUri.length > 0 ? bannerUri : "string",
  //                 tin: "string",
  //                 occupation: "string",
  //                 isGroupEntity: entityTypeOptionsValue, // entityTypeOption
  //                 areaOfActivity: activityOptionsValue, // activityOption
  //                 isParentEntity: true,
  //                 contactId: contactResponse.contactDetails.contactId,
  //                 entityAddressId: successResult.addressDetails.addressId,
  //                 cae: "string",
  //                 parentId: null,
  //                 businessRegistrationUri: businessRegistrationUri,
  //                 mandatedStatementUri: mandatedStatementUri,
  //               };
  //               dispatch(addUserDetail(userDetails));
  //               dispatch(getProductList());
  //               dispatch(setBannerUri(""));
  //               dispatch(setProfileUri(""));
  //               dispatch(setDisableFrom(5));
  //               dispatch(setCurrentTab(4));
  //             });
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //           alert("Address or Contact details are not added");
  //         });
  //       await uploadDocumnetDetails(
  //         FileType.businessRegistration,
  //         businessRegistrationUri
  //       );
  //       if (mandatedStatementUri?.length > 0) {
  //         await uploadDocumnetDetails(
  //           FileType.mandatedStatement,
  //           mandatedStatementUri
  //         );
  //       }
  //     }
  //   }
  // };

  const updateSharedData = async (data) => {

    const {
      name,
      NIF_NIPC,
      mobile,
      companyName,
      email,
      locality,
      address,
      postalCode1,
      postalCode2,
      designation,
      addressTitle,
      emailForAddress,
      phone,
      houseHold,
      contactName,
      ...addressData
    } = data;
    if (identificationType === ComponentType.IDENTIFICATION_TYPE) {
      if (position === null) {
        setPositionError(true);
      } else {
        setPositionError(false);
        const data = {
          email: emailForAddress.toLowerCase(),
          password: "Test123",
          userType: UserType.entity,
          status: RegistrationStatus.registering,
          createdBy: userId,
        };
        setSharedData({
          data,
          identificationType,
          UserType,
          RegistrationStatus,
          businessRegistrationUri,
          select1,
          select2,
          select3,
          position,
          profileOptionsValue,
          profileUri,
          bannerUri,
          entityTypeOptionsValue,
          activityOptionsValue,
          mandatedStatementUri
        });
      }
    } else {
      setSharedData({
        data,
        identificationType,
        UserType,
        RegistrationStatus,
        businessRegistrationUri,
        select1,
        select2,
        select3,
        position,
        profileOptionsValue,
        profileUri,
        bannerUri,
        entityTypeOptionsValue,
        activityOptionsValue,
        mandatedStatementUri
      });
      // dispatch(setBannerUri(""));
      // dispatch(setProfileUri(""));
      dispatch(setDisableFrom(5));
      dispatch(setCurrentTab(4));

    }

  };

  const fetchCoordinates = async (address) => {
    try {
      address = address.replaceAll(".", "");

      const queries = [
        address,
        `${methods.getValues("addressHousehold")}, ${methods.getValues("postalCode1")}-${methods.getValues("postalCode2")}, ${methods.getValues("locality")}, Portugal`,
        `${methods.getValues("postalCode1")}-${methods.getValues("postalCode2")}, ${methods.getValues("locality")}, Portugal`,
      ];

      for (const query of queries) {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&countrycodes=pt&q=${encodeURIComponent(query)}`
        );

        const data = await response.json();

        if (data && data.length > 0) {
          setPosition({
            lat: parseFloat(data[0].lat),
            lng: parseFloat(data[0].lon),
          });

          setPositionError(false);
          return;
        }
      }

      console.warn("Morada não encontrada:", address);
    } catch (err) {
      console.error("Erro ao buscar coordenadas:", err);
      setPositionError(true);
    }
  };
  const buildFullAddress = (data, select1, select2, select3) => {
    const parts = [
      data.houseHold,
      `${data.postalCode1}-${data.postalCode2}`,
      data.locality,
      select3,   // freguesia
      select2,   // concelho
      select1,   // distrito
    ];

    // Remove vazios e duplicados mantendo a ordem
    return [...new Set(parts.filter(Boolean))].join(", ");
  };




  useEffect(() => {
    if (editAddress) {
      const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
      fetchCoordinates(fullAddress);
    }
  }, [editAddress, select1, select2, select3]);




  return (
    <>
      <Grid
        marginTop="20px"
        container
        spacing={responsiveValue("", "", "", "2", "2", "0")}
        direction={responsiveValue("", "", "", "row", "row", "column-reverse")}
        justifyContent={"space-evenly"}
      >
        <Grid
          lg={5}
          xl={5}
          item
          marginTop={responsiveValue("", "", "", "0", "0", "90px")}
        >
          <Grid>
            <FormProvider methods={methods} onSubmit={handleSubmit(updateSharedData)}>
              <Stack spacing={3}>
                {!identificationType && (
                  <Paper sx={{ padding: "20px" }}>
                    <Typography>Identificação</Typography>
                    <RHFTextField
                      id="outlined-basic"
                      label="NIF/ NIPC*"
                      variant="outlined"
                      name="NIF_NIPC"
                      sx={{ marginTop: "20px" }}
                      fullWidth
                      inputProps={{ maxLength: 9 }}
                    />


                    <RHFTextField
                      id="outlined-basic"
                      // label={t("name") + "*"}
                      label={"Entidade*"}
                      variant="outlined"
                      name="companyName"
                      sx={{ marginTop: "20px" }}
                      fullWidth
                    />
                  </Paper>
                )}
                {identificationType && (
                  <Paper sx={{ padding: "20px" }}>
                    <Typography>Identificação</Typography>
                    <RHFTextField
                      id="outlined-basic"
                      label={t("name") + "*"}
                      variant="outlined"
                      name="companyName"
                      sx={{ marginTop: "20px" }}
                      fullWidth
                    />
                  </Paper>
                )}
                <Paper sx={{ p: "20px" }}>
                  {identificationType !== ComponentType.IDENTIFICATION_TYPE && (
                    <Typography>{t("address")}</Typography>
                  )}
                  {/* <RHFTextField
                    id="outlined-basic"
                    label={
                      identificationType === ComponentType.IDENTIFICATION_TYPE
                        ? t("nameEstablishment")
                        : t("addressTitle")
                    }
                    variant="outlined"
                    name="addressTitle"
                    sx={{
                      marginTop: "20px",
                      marginBottom:
                        identificationType !== ComponentType.IDENTIFICATION_TYPE
                          ? 0
                          : "20px",
                    }}
                    fullWidth
                  /> */}
                  {/* {console.log("dsdsdsdsd", methods.formState.errors , Object.entries(methods.formState.errors))} */}
                  {identificationType === ComponentType.IDENTIFICATION_TYPE && (
                    <Typography>{t("address")}</Typography>
                  )}
                  <RHFTextField
                    id="outlined-basic"
                    label={t("addressTitle") + "*"}
                    variant="outlined"
                    name="addressTitle"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("houseHold") + "*"}
                    variant="outlined"
                    name="houseHold"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                    onBlur={() => {
                      const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                      fetchCoordinates(fullAddress);
                    }}
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("phone") + "*"}
                    variant="outlined"
                    name="phone"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                    inputProps={{ maxLength: 12 }}
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("emailForAddress") + "*"}
                    variant="outlined"
                    name="emailForAddress"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: responsiveValue(
                        "",
                        "",
                        "",
                        "row",
                        "row",
                        "column"
                      ),
                    }}
                  >

                    <Controller
                      name="district"
                      control={methods.control}
                      defaultValue={defaultValues.district}
                      rules={{ required: true }}
                      render={({ field, fieldState: { error } }) => (
                        <Autocomplete
                          onBlur={() => {
                            const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                            fetchCoordinates(fullAddress);
                          }}
                          noOptionsText={t("noOptionsText")}
                          disablePortal
                          //options={AddressData.map((address) => address.district)}
                          options={AddressData.map((item) => item.district).sort((a, b) => a.localeCompare(b, 'pt-PT'))}
                          getOptionLabel={(option) => option}
                          sx={{
                            width: responsiveValue("", "", "", "32%", "32%", "100%"),
                            marginTop: "20px",
                          }}
                          isOptionEqualToValue={(option, value) => option === value}
                          value={field.value || select1 || null}
                          onChange={(event, value) => {
                            field.onChange(value);

                            // Handle your additional logic based on the selected value
                            if (value) {
                              setSelect1(value);
                              setSelect2(sharedData.select2);
                              setSelect3(sharedData.select3);
                            } else {
                              // Handle the case where the value is cleared or set to null
                              setSelect1(sharedData.select1);
                              setSelect2(sharedData.select2);
                              setSelect3(sharedData.select3);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              name="district"
                              helperText={error?.message}
                              error={error}
                              {...params}
                              label={t("district") + "*"}
                            />
                          )}
                        />
                      )}
                    />

                    <Controller
                      name="county"
                      control={methods.control}
                      defaultValue={defaultValues.county}
                      render={({ field, fieldState: { error } }) => (
                        <Autocomplete
                          onBlur={() => {
                            const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                            fetchCoordinates(fullAddress);
                          }}
                          noOptionsText={t("noOptionsText")}
                          disablePortal
                          // options={
                          //   select1
                          //     ? AddressData.find(({ district }) => district === select1)?.county.map(
                          //         (county) => county.countyName
                          //       )
                          //     : []
                          // }
                          options={
                            select1
                              ? (
                                AddressData.find(
                                  ({ district }) => district === select1
                                )?.county
                                  ?.map((county) => county.countyName)
                                  .sort((a, b) => a.localeCompare(b, "pt-PT"))
                              ) || []
                              : []
                          }
                          sx={{
                            width: responsiveValue("", "", "", "", "32%", "32%", "100%"),
                            marginTop: "20px",
                          }}
                          onChange={(event, value) => {
                            field.onChange(value);
                            setSelect2(value);
                          }}
                          isOptionEqualToValue={(option, value) => option === value}
                          getOptionLabel={(option) => option}
                          value={field.value || select2 || null}
                          renderInput={(params) => (
                            <TextField
                              name="county"
                              helperText={error?.message}
                              error={error}
                              {...params}
                              label={t("county") + "*"}
                            />
                          )}
                        />
                      )}
                    />

                    <Controller
                      name="parshi"
                      control={methods.control}
                      defaultValue={defaultValues.parshi}
                      render={({ field, fieldState: { error } }) => (
                        <Autocomplete
                          onBlur={() => {
                            const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                            fetchCoordinates(fullAddress);
                          }}
                          noOptionsText={t("noOptionsText")}
                          disablePortal
                          // options={
                          //   select2
                          //     ? AddressData.find(({ district }) => district === select1)
                          //         .county?.find(({ countyName }) => countyName === select2)
                          //         .fregusias.map((subDivision) => subDivision.freguesiaName)
                          //     : []
                          // }
                          options={
                            select2
                              ? (
                                AddressData.find(({ district }) => district === select1)
                                  ?.county
                                  ?.find(({ countyName }) => countyName === select2)
                                  ?.fregusias
                                  ?.map(subDivision => subDivision.freguesiaName)
                                  ?.sort((a, b) => a.localeCompare(b, "pt-PT"))
                              ) || []
                              : []
                          }
                          isOptionEqualToValue={(option, value) => option === value}
                          getOptionLabel={(option) => option}
                          sx={{
                            width: responsiveValue("", "", "", "32%", "32%", "100%"),
                            marginTop: "20px",
                          }}
                          onChange={(event, value) => {
                            setSelect3(value);
                            field.onChange(value);
                          }}
                          value={field.value || select3 || null}
                          renderInput={(params) => (
                            <TextField
                              name="parshi"
                              helperText={error?.message}
                              error={error}
                              {...params}
                              label={t("parshi") + "*"}
                            />
                          )}
                        />
                      )}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: responsiveValue("", "", "", "", "", "row"),
                    }}
                  >
                    <Box
                      sx={{
                        width: "40%",
                        display: "flex",
                        marginTop: "20px",
                        alignItems: "flex-start",
                      }}
                    >
                      <RHFTextField
                        id="outlined-basic"
                        label={t("postcard") + "*"}
                        name="postalCode1"
                        variant="outlined"
                        sx={{ width: "50%" }}
                        inputProps={{ maxLength: 4 }}
                        onBlur={() => {
                          const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                          fetchCoordinates(fullAddress);
                        }}
                      />
                      <Box
                        sx={{
                          width: "17px",
                          height: "2px",
                          background: "gray",
                          marginX: "5px",
                          marginTop: "29px"
                        }}
                      >
                        {" "}
                      </Box>

                      <RHFTextField
                        id="outlined-basic"
                        variant="outlined"
                        name="postalCode2"
                        sx={{ width: "50%" }}
                        label="*"
                        className="noLabel"
                        inputProps={{ maxLength: 3 }}
                        onBlur={() => {
                          const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                          fetchCoordinates(fullAddress);
                        }}
                      />
                    </Box>

                    {/* 2 */}

                    <Box
                      sx={{
                        width: "58%",
                      }}
                    >
                      <RHFTextField
                        id="outlined-basic"
                        label={t("locality") + "*"}
                        variant="outlined"
                        name="locality"
                        sx={{ marginTop: "20px" }}
                        fullWidth
                        onBlur={() => {
                          const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                          fetchCoordinates(fullAddress);
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: 1,
                      backgroundColor: "#e5f1ff",
                      display: "flex",
                      alignItems: "center",
                      borderRadius: 1.5,
                      p: 1.5,
                      my: 2,
                    }}
                  >
                    <InfoIcon sx={{ color: "#0167d6" }} />
                    <Typography variant="body2" fontWeight={500} mx={2}>
                      {`${t("mapInfo")}`}
                    </Typography>
                  </Box>
                  <Box sx={{ width: 1, height: 400, py: 1 }}>
                    <MapLeaflet
                      isDirectionAble={false}
                      isSearchAble={true}
                      position={position}
                      setPosition={setMarkerSDefaultPosition}
                      t={t}
                      onAddressFound={(addr) => {
                        methods.setValue(
                          "houseHold",
                          `${addr.road || ""} ${addr.house_number || ""}`.trim()
                        );

                        const [pc1 = "", pc2 = ""] = (addr.postcode || "").split("-");
                        methods.setValue("postalCode1", pc1);
                        methods.setValue("postalCode2", pc2);

                        methods.setValue(
                          "locality",
                          addr.city ||
                          addr.town ||
                          addr.village ||
                          addr.municipality ||
                          ""
                        );
                        // Distrito pelo código ISO
                        const isoCode = addr["ISO3166-2-lvl6"];
                        const isoNumber = isoCode ? parseInt(isoCode.split("-")[1], 10) : null;

                        // encontra o distrito
                        // const districtOption = AddressData.find(d => d.code === isoNumber);
                        // setSelect1(districtOption?.district || addr.city || county|| "");    // distrito
                        // console.log(AddressData)
                        // // Concelho
                        // const countyOption = districtOption?.county.find(c => c.countyName === addr.county);
                        // setSelect2(countyOption?.countyName || addr.county || "");
                        const districtOption = isoNumber
                          ? AddressData.find(d => String(d.code) === String(isoNumber))
                          : null;

                        setSelect1(
                          districtOption?.district ||
                          addr.state ||
                          addr.city ||
                          ""
                        );

                        // Concelho
                        const possibleCountyNames = [
                          addr.county,
                          addr.municipality,
                          addr.city
                        ].filter(Boolean);

                        const countyOption = districtOption?.county.find(c =>
                          possibleCountyNames.some(name =>
                            name?.toLowerCase().trim() ===
                            c.countyName?.toLowerCase().trim()
                          )
                        );

                        setSelect2(
                          countyOption?.countyName ||
                          possibleCountyNames[0] ||
                          ""
                        );
                        // Freguesia
                        const possibleNames = [
                          addr.city_district,
                          addr.suburb,
                          addr.neighbourhood,
                          addr.village,
                          addr.town
                        ].filter(Boolean);

                        const subDivisionOption =
                          countyOption?.freguesias?.find(f =>
                            possibleNames.some(name =>
                              name?.toLowerCase().trim() ===
                              f.freguesiaName?.toLowerCase().trim()
                            )
                          );

                        setSelect3(
                          subDivisionOption?.freguesiaName ||
                          possibleNames[0] ||
                          ""
                        );
                        // const subDivisionOption = countyOption?.fregusias.find(f => f.freguesiaName === addr.village || addr.neighbourhood);
                        // setSelect3(subDivisionOption?.freguesiaName || addr.city_district || addr.suburb || addr.town || "" );

                        $(".MuiFormLabel-root").addClass('css-kw1843-MuiFormLabel-root-MuiInputLabel-root');
                      }}


                    />
                    {positionError && (
                      <Typography variant="subtitle2" color="error" py={1}>
                        {t("selectYourPosition")}
                      </Typography>
                    )}
                  </Box>
                </Paper>
                {identificationType !== ComponentType.IDENTIFICATION_TYPE && (
                  <Paper sx={{ p: "20px" }}>
                    <Typography>{t("document")}</Typography>
                    <Controller
                      name="businessRegistration"
                      control={methods.control}
                      defaultValue={
                        defaultValues.businessRegistration &&
                        defaultValues.businessRegistration[0]
                      }
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          id="outlined-basic"
                          label={"Registo comercial/Estatutos da IPSS*"}
                          variant="outlined"
                          inputRef={businessRegistrationRef}
                          defaultValue={defaultValues.businessRegistration}
                          value={field.value ? field.value[0].name : ''}
                          sx={{ marginTop: "20px" }}
                          name="businessRegistration"
                          helperText={error?.message}
                          error={error}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <>
                                {businessRegPercentage === 0 && (
                                  <Button
                                    variant="contained"
                                    aria-label="upload"
                                    component="label"
                                    sx={{ borderRadius: "4px" }}
                                  >
                                    {'Selecionar'}
                                    <input
                                      hidden
                                      accept=".pdf"
                                      id="choose-file"
                                      type="file"
                                      onChange={(e) => {
                                        const selectedFile = e.target.files[0];
                                        if (selectedFile) {
                                          const fileType = selectedFile.type;
                                          if (fileType === "application/pdf") {
                                            handleBusinessFileUpload(e);
                                            const reader = new FileReader();
                                            reader.onloadend = () => {
                                              field.onChange([e.target.files[0]]);
                                            };
                                            reader.readAsDataURL(e.target.files[0]);
                                          } else {
                                            enqueueSnackbar({
                                              variant: "error",
                                              message: "Selecione um ficheiro tipo pdf para o registo comercial",
                                            });

                                          }
                                        }

                                      }}
                                    />
                                  </Button>
                                )}
                                {businessRegPercentage > 0 && (
                                  <CircularProgress
                                    variant="determinate"
                                    value={businessRegPercentage}
                                  />
                                )}
                              </>
                            ),
                          }}
                          fullWidth
                        />
                      )}
                    />
                    <Controller
                      name="mandatedStatement"
                      control={methods.control}
                      defaultValue={defaultValues.mandatedStatement && defaultValues.mandatedStatement[0]}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          id="outlined-basic"
                          label={
                            <>
                              {t("mandatedStatement") + "*"}
                              <Tooltip title="Declaração da entidade que ateste que tem poderes para a representar no âmbito desta plataforma.">
                                <InfoIcon sx={{ fontSize: 16, marginLeft: 1, cursor: 'pointer' }} />
                              </Tooltip>
                            </>
                          }

                          variant="outlined"
                          inputRef={mandatedStatementRef}
                          value={field.value ? field.value[0].name : ''}
                          sx={{ marginTop: "20px" }}
                          name="mandatedStatement"
                          helperText={error?.message}
                          error={error}
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <>
                                {mandatePercentage === 0 && (
                                  <Button
                                    variant="contained"
                                    aria-label="upload"
                                    component="label"
                                    sx={{ borderRadius: "4px" }}
                                  >
                                    {'Selecionar'}
                                    <input
                                      hidden
                                      accept=".pdf"
                                      id="choose-file"
                                      type="file"
                                      onChange={(e) => {
                                        const selectedFile = e.target.files[0];
                                        if (selectedFile) {
                                          const fileType = selectedFile.type;
                                          if (fileType === "application/pdf") {
                                            handleMandateFileUpload(e);
                                            const reader = new FileReader();
                                            reader.onloadend = () => {
                                              field.onChange([e.target.files[0]]);
                                            };
                                            reader.readAsDataURL(e.target.files[0]);
                                          } else {
                                            enqueueSnackbar({
                                              variant: "error",
                                              message: "Selecione um ficheiro tipo pdf para a declaração mandatada",
                                            });
                                          }
                                        }

                                      }}
                                    />
                                  </Button>
                                )}
                                {mandatePercentage > 0 && (
                                  <CircularProgress
                                    variant="determinate"
                                    value={mandatePercentage}
                                  />
                                )}
                              </>
                            ),
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Paper>
                )}
                <Paper sx={{ padding: "20px" }}>
                  <Typography>{"Contato principal"}</Typography>

                  <Divider />

                  <RHFTextField
                    id="outlined-basic"
                    label={t("contactName") + "*"}
                    variant="outlined"
                    name="contactName"
                    // type='number'
                    sx={{ marginTop: "20px" }}
                    fullWidth
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("mobile") + "*"}
                    variant="outlined"
                    name="mobile"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                    inputProps={{ maxLength: 9 }}
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("email") + "*"}
                    variant="outlined"
                    name="email"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("designation") + "*"}
                    variant="outlined"
                    name="designation"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                  />
                </Paper>
              </Stack>

              <Box
                sx={{
                  paddingX: "5px",
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    marginTop: responsiveValue(
                      "",
                      "",
                      "",
                      "0px",
                      "0px",
                      "10px"
                    ),
                    marginLeft: responsiveValue(
                      "",
                      "",
                      "",
                      "0px",
                      "0px",
                      "10px"
                    ),
                  }}
                >
                  {" "}
                  {identificationType ? (
                    <Button
                      onClick={() => {
                        navigate("/dashboard/manage-branches", { replace: true });
                        dispatch(setDashboardTab("manageBranches"));
                      }}
                      sx={{
                        backgroundColor: "#FFEEEE",
                        color: "#FF0000",
                        marginTop: responsiveValue(
                          "",
                          "",
                          "",
                          "0px",
                          "0px",
                          "10px"
                        ),
                        marginLeft: responsiveValue(
                          "",
                          "",
                          "",
                          "0px",
                          "0px",
                          "10px"
                        ),
                        borderRadius: "4px",
                      }}
                      size="large"
                      variant="contained"
                      color="grey"
                    >
                      <Typography variant="bold"
                      // sx={{backgroundColor:"#FFEEEE" , color: "#FF0000"}}

                      >Cancelar
                      </Typography>
                    </Button>
                  ) : (
                    <BackButton style={{}} />
                  )}
                </Box>
                <LoadingButton
                  sx={{
                    marginTop: responsiveValue(
                      "",
                      "",
                      "",
                      "0px",
                      "0px",
                      "10px"
                    ),
                    marginRight: responsiveValue(
                      "",
                      "",
                      "",
                      "0px",
                      "0px",
                      "10px"
                    ),
                    borderRadius: "4px",
                  }}
                  size="large"
                  variant="contained"
                  onSubmit={updateSharedData}
                  type="submit"
                  loading={loading}
                >
                  <Typography variant="bold">
                    {identificationType ? t("save") : t("continue")}
                  </Typography>
                  {!identificationType && <ArrowForward fontSize="16px" />}
                </LoadingButton>
              </Box>

              {!methods.formState.isValid && (
                <ConfirmDialog
                  open={methods.formState.submitCount > submitCount}
                  handleClose={() => {
                    setSubmitCount(methods.formState.submitCount);
                  }}
                  title={t("errorMessage")}
                  content={
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {" "}
                      {Object.entries(methods.formState.errors)?.map((key, index) => (

                        <Typography
                          variant="subtitle2"
                          sx={{
                            color: "",
                            fontWeight: "600",
                            px: 0.5,
                          }}
                          key={key}
                        >
                          {identificationType && key[0] === "addressTitle"
                            ? t("nameEstablishment")
                            : t(
                              `${key[0] === "postalCode1" ||
                                key[0] === "postalCode2"
                                ? "postcard"
                                : key[0] === "NIF_NIPC"
                                  ? "NIF / NIPC"
                                  : key[0]
                              }`
                            )}
                          <span style={{ padding: "2px" }}>{Object.entries(methods.formState.errors).length == (index + 1) ? ". " : ", "}</span>
                        </Typography>
                      ))}
                    </Box>
                  }
                  // title="hi"
                  onConfirm={() => {
                    // methods.clearErrors();
                    setSubmitCount(methods.formState.submitCount);
                  }}
                  cancelButtonTitle=""
                  confirmButtonTitle="Compreendi"
                />
              )}
            </FormProvider>
          </Grid>
        </Grid>

        <Grid lg={5} xl={5} item>
          {!identificationType && (
            <Paper
              sx={{
                padding: "20px",
                marginTop: responsiveValue("", "", "", "0", "0", "35px"),
              }}
            >
              <Stack spacing={3}>
                <Typography>Página de perfil</Typography>
                <Divider />
                <BlogPostCard
                  post={{
                    author: {
                      className: "fotoPerfil",
                      avatarUrl:

                        profileUri.length > 0
                          ? profileUri
                          : "static/illustrations/illustration_defaultavatar.png",
                      name: "default avatar",
                    },
                    comment: 59011,
                    cover:
                      bannerUri.length > 0
                        ? bannerUri
                        : "static/illustrations/illustration_default_banner.jpg",
                    favorite: 82541,
                    id: "25ece2a5-d071-4ee2-972b-6c039c51664a",
                    share: 8056,
                    title: "Fresh Prince",
                    view: 62222,

                  }}
                />
              </Stack>
            </Paper>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default IdentificationRegister;
